/**
 * Formats a workflow template to ensure all performer values are valid enum values
 * (admin or member or both)
 * 
 * @param {Object} template - The workflow template to format
 * @returns {Object} - The formatted template
 */
const formatTemplateForImport = (template) => {
  // Deep clone the template to avoid mutating the original
  const formattedTemplate = JSON.parse(JSON.stringify(template));
  
  // Process all steps and their actions
  if (formattedTemplate.steps && Array.isArray(formattedTemplate.steps)) {
    formattedTemplate.steps.forEach(step => {
      if (step.actions && Array.isArray(step.actions)) {
        step.actions.forEach(action => {
          // Replace any custom performer values with 'admin'
          // The system only accepts 'admin', 'member', or 'both'
          if (action.performer && !['admin', 'member', 'both'].includes(action.performer)) {
            action.performer = 'admin';
          }
        });
      }
    });
  }
  
  return formattedTemplate;
};

export default formatTemplateForImport;
